<script setup lang="ts">
import type { ElementalTypeEnum } from '~~/src/types/elemental'
import MenuItem from '@/components/FloatMenu/FloatMenuOption/indev.vue'
import ElementalIconPicker from '@/components/Elemental/ElemetalIconPicker/index.vue'
import { useCreateElemental } from '~~/src/composables/mutations/elemetal/useCreateElemental'
import { elementalFactory } from '~~/src/utils/elementals'
import { getElementTypeColor } from '~~/src/composables/theme'

const props = defineProps<Props>()

defineOptions({
  name: 'CreateElementalOption',
})

interface Props {
  type: ElementalTypeEnum
  label: string
}

const router = useRouter()
const user = useUser()
const colors = getElementTypeColor(props.type)
const { mutate: createElemental, isPending } = useCreateElemental()
const route = getElementalTypeRoute(props.type)

const handlerCreateElemental = () => {
  if (!user.value)
    return router.push(useGetLoginURL())
  const elementalData = elementalFactory(props.type, {
    title: `Untitled ${props.label}`,
  })

  createElemental({ elementalType: props.type, elemental: elementalData }, {
    onSuccess: (result) => {
      router.push(`/${route}/${result?.id}/edit`)
    },
  })
}
</script>

<template>
  <MenuItem
    class="gap-3"
    @select="handlerCreateElemental()"
  >
    <template #icon-wrapper>
      <div :style="{ background: colors[1], color: colors[0] }" class="h-7 w-7 rounded-1 flex items-center justify-center">
        <ElementalIconPicker :type="props.type" />
      </div>
    </template>
    <span class="font-inter font-700 text-sm leading-[22.4px]">
      {{ props.label }}
    </span>
  </MenuItem>
  <Teleport v-if="isPending" to="body">
    <div class="absolute h-100[dvh] w-100[dvh] inset-0 z-999">
      <LoadingOverlay :message="`Creating ${props.label}...`" />
    </div>
  </Teleport>
</template>
